module.exports = {"Phase A":{"A":["1","2","3","4","Roof"],"B":["1","2","3","4","Roof"],"C":["1","2","3","4","5","Roof"],"D":["1","2","3","4","5","6","Roof"],"E":["1","2","3","4","5","6","Roof"],"F":["1","2","3","4","5","6","Roof"],"G":["1","2","3","4","5","6","7","8","9","10","Roof"],"H":["1","2","3","4","5","6","7","8","9","Roof"],"I":["1","2","3","4","5","6","7","8","9","Roof"],"J":["1","2","3","4","5","6","7","8","9","Roof"]},"Phase B":{},"Site Wide":{},"Eastern Access":{},"Western Access":{}}


//////////////////
// WEBPACK FOOTER
// ./src/data/southall.json
// module id = 129
// module chunks = 0